module.exports = __webpack_public_path__ + "img/antes_despues_285.5505e818.png";